(function(){
  var root = document.getElementById("el-numero");
  if (!root) return;

  var dataEl = document.getElementById("nData");
  if (!dataEl) return;
  var DATA;
  try { DATA = JSON.parse(dataEl.textContent); }
  catch(err) { console.error("Numerologie: JSON invalide", err); return; }

  var form = document.getElementById("nForm");
  var errorEl = document.getElementById("nError");
  var result = document.getElementById("nResult");
  var dInput = document.getElementById("nDay");
  var mInput = document.getElementById("nMonth");
  var yInput = document.getElementById("nYear");
  var nBig = document.getElementById("nBigNumber");
  var nMasterWrap = document.getElementById("nMasterWrap");
  var nArch = document.getElementById("nArchetype");
  var nPitch = document.getElementById("nPitch");
  var nCalc = document.getElementById("nCalcFlow");
  var panes = root.querySelectorAll(".n-pane");
  var tabs = root.querySelectorAll(".n-tab");
  var nChakra = document.getElementById("nChakra");
  var nElement = document.getElementById("nElement");
  var nColor = document.getElementById("nColor");
  var nStones = document.getElementById("nStones");
  var nReset = document.getElementById("nReset");
  var nCaptureForm = document.getElementById("nCaptureForm");
  var nCaptureMsg = document.getElementById("nCaptureMsg");
  var nCollectionCta = document.getElementById("nCollectionCta");
  var currentNumber = null;

  function pad2(v) {
    var s = String(v);
    if (s.length >= 2) return s;
    return "0" + s;
  }

  function sumDigits(n) {
    var s = String(n);
    var total = 0;
    for (var i = 0; i < s.length; i++) {
      total += parseInt(s.charAt(i), 10);
    }
    return total;
  }

  function isMaster(n) { return n === 11 || n === 22 || n === 33; }

  function reduce(n) {
    while (n > 9 && !isMaster(n)) { n = sumDigits(n); }
    return n;
  }

function computePath(d, m, y) {
    var total = sumDigits(d) + sumDigits(m) + sumDigits(y);
    return {
      day: d, month: m, year: y,
      total: total, final: reduce(total)
    };
  }

  function validateDate(d, m, y) {
    if (isNaN(d) || isNaN(m) || isNaN(y)) return "Merci de remplir les trois champs.";
    if (d < 1 || d > 31) return "Jour invalide (1 a 31).";
    if (m < 1 || m > 12) return "Mois invalide (1 a 12).";
    if (y < 1900 || y > 2099) return "Annee invalide (1900 a 2099).";
    var dt = new Date(y, m - 1, d);
    if (dt.getDate() !== d || dt.getMonth() !== m - 1 || dt.getFullYear() !== y) {
      return "Cette date n'existe pas.";
    }
    return null;
  }

  function chipsFrom(str, sep) {
    var arr = String(str).split("");
    var out = "";
    for (var i = 0; i < arr.length; i++) {
      if (i > 0) out += sep;
      out += "<span class=\"n-calc-chip\">" + arr[i] + "</span>";
    }
    return out;
  }

  function buildCalcFlow(calc) {
    var plus = "<span class=\"n-calc-op\">+</span>";
    var d = chipsFrom(pad2(calc.day), plus);
    var m = chipsFrom(pad2(calc.month), plus);
    var y = chipsFrom(calc.year, plus);
    return d + plus + m + plus + y
      + "<span class=\"n-calc-op\">=</span><span class=\"n-calc-chip\">" + calc.total + "</span>"
      + "<span class=\"n-calc-op\">\u2192</span><span class=\"n-calc-final\">" + calc.final + "</span>";
  }

  function animateNumber(from, to, el, duration) {
    var start = Date.now();
    function step() {
      var elapsed = Date.now() - start;
      var progress = Math.min(elapsed / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = Math.floor(from + (to - from) * eased);
      if (progress < 1) { requestAnimationFrame(step); }
      else { el.textContent = to; }
    }
    requestAnimationFrame(step);
  }

  function renderResult(calc) {
    var n = calc.final;
    var data = DATA[String(n)];
    if (!data) return;
    currentNumber = n;

    animateNumber(0, n, nBig, 1100);
    nMasterWrap.style.display = isMaster(n) ? "block" : "none";

    nArch.textContent = data.archetype;
    nPitch.textContent = data.pitch;
    nChakra.textContent = data.chakra;
    nElement.textContent = data.element;
    nColor.textContent = data.color;

    nCalc.innerHTML = buildCalcFlow(calc);

    var qualHtml = "";
    for (var i = 0; i < data.traits.qualities.length; i++) {
      qualHtml += "<li>" + data.traits.qualities[i] + "</li>";
    }
    var chalHtml = "";
    for (var j = 0; j < data.traits.challenges.length; j++) {
      chalHtml += "<li>" + data.traits.challenges[j] + "</li>";
    }

    panes[0].innerHTML = data.mission;
    panes[1].innerHTML =
      "<div class=\"n-list-grid\">" +
        "<div class=\"n-list-card n-qualities\"><h4>\u2726 Vos qualites</h4><ul>" + qualHtml + "</ul></div>" +
        "<div class=\"n-list-card n-challenges\"><h4>\u26A0 Vos defis</h4><ul>" + chalHtml + "</ul></div>" +
      "</div>";
    panes[2].innerHTML = data.love;
    panes[3].innerHTML = data.work;

    for (var t = 0; t < tabs.length; t++) {
      tabs[t].classList.toggle("is-active", t === 0);
    }
    for (var p = 0; p < panes.length; p++) {
      panes[p].classList.toggle("is-active", p === 0);
    }

    var stonesHtml = "";
    for (var k = 0; k < data.stones.length; k++) {
      var s = data.stones[k];
      stonesHtml += "<a class=\"n-stone\" href=\"" + s.url + "\">"
        + "<h3 class=\"n-stone-name\">" + s.nom + "</h3>"
        + "<p class=\"n-stone-desc\">" + s.desc + "</p>"
        + "<span class=\"n-stone-link\">Decouvrir</span>"
        + "</a>";
    }
    nStones.innerHTML = stonesHtml;

    nCollectionCta.href = data.stones[0].url;
    nCollectionCta.innerHTML = "Decouvrir la collection " + data.stones[0].nom + " \u2726";

    result.classList.add("is-open");
    setTimeout(function() {
      result.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 100);
  }

  if (form) {
    form.addEventListener("submit", function(e) {
      e.preventDefault();
      errorEl.textContent = "";
      var d = parseInt(dInput.value, 10);
      var m = parseInt(mInput.value, 10);
      var y = parseInt(yInput.value, 10);
      var err = validateDate(d, m, y);
      if (err) { errorEl.textContent = err; return; }
      renderResult(computePath(d, m, y));
    });
  }

  for (var ti = 0; ti < tabs.length; ti++) {
    (function(tab) {
      tab.addEventListener("click", function() {
        var target = tab.getAttribute("data-tab");
        for (var a = 0; a < tabs.length; a++) {
          tabs[a].classList.toggle("is-active", tabs[a] === tab);
        }
        for (var b = 0; b < panes.length; b++) {
          panes[b].classList.toggle("is-active", panes[b].getAttribute("data-pane") === target);
        }
      });
    })(tabs[ti]);
  }

  if (nReset) {
    nReset.addEventListener("click", function() {
      result.classList.remove("is-open");
      form.reset();
      dInput.focus();
      window.scrollTo({ top: root.offsetTop - 20, behavior: "smooth" });
    });
  }

  if (nCaptureForm) {
    nCaptureForm.addEventListener("submit", function(e) {
      e.preventDefault();
      var email = document.getElementById("nEmail").value.trim();
      var listId = root.getAttribute("data-klaviyo-list");
      nCaptureMsg.className = "n-capture-msg";
      nCaptureMsg.textContent = "Envoi en cours...";

      // 1. Track identity + event via _learnq (pour declencher le flow et l'evenement)
      if (window._learnq) {
        window._learnq.push(["identify", { "$email": email, "Chemin de Vie": String(currentNumber) }]);
        window._learnq.push(["track", "Calcul Chemin de Vie", { email: email, chemin_de_vie: currentNumber, source: "numerologie_chemin_de_vie" }]);
      }

      // 2. IMPORTANT : abonnement officiel via API Klaviyo (statut "Subscribed")
      // Cette etape permet l'envoi d'emails marketing
      if (listId) {
        var parts = listId.split(":");
        var companyId = (parts[0] || "").trim();
        var targetListId = (parts[1] || listId).trim();

        fetch("https://a.klaviyo.com/client/subscriptions/?company_id=" + encodeURIComponent(companyId), {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "revision": "2024-10-15"
          },
          body: JSON.stringify({
            data: {
              type: "subscription",
              attributes: {
                custom_source: "Calculateur Numerologie",
                profile: {
                  data: {
                    type: "profile",
                    attributes: {
                      email: email,
                      properties: { "Chemin de Vie": String(currentNumber) },
                      subscriptions: {
                        email: {
                          marketing: {
                            consent: "SUBSCRIBED"
                          }
                        }
                      }
                    }
                  }
                }
              },
              relationships: {
                list: { data: { type: "list", id: targetListId } }
              }
            }
          })
        }).then(function(response) {
          if (response.ok || response.status === 202) {
            nCaptureMsg.classList.add("ok");
            nCaptureMsg.textContent = "Merci ! Votre guide arrive dans votre boite mail.";
            nCaptureForm.reset();
          } else {
            console.error("Klaviyo subscription error:", response.status);
            nCaptureMsg.classList.add("ok");
            nCaptureMsg.textContent = "Merci ! Votre guide arrive dans votre boite mail.";
            nCaptureForm.reset();
          }
        }).catch(function(err) {
          console.error("Klaviyo fetch error:", err);
          nCaptureMsg.classList.add("err");
          nCaptureMsg.textContent = "Une erreur est survenue. Merci de reessayer.";
        });
      } else {
        nCaptureMsg.classList.add("ok");
        nCaptureMsg.textContent = "Merci ! Votre guide arrive dans votre boite mail.";
        nCaptureForm.reset();
      }
    });
  }

  if (dInput) {
    dInput.addEventListener("input", function() {
      if (dInput.value.length >= 2) mInput.focus();
    });
  }
  if (mInput) {
    mInput.addEventListener("input", function() {
      if (mInput.value.length >= 2) yInput.focus();
    });
  }
})();